import { cB, cM } from '../../../_utils/cssr'

export default cB('upload', [
  cM('rtl', `
    direction: rtl;
    text-align: right;
  `)
])
